
import { serverUrl, getheader, setErrorDialog, getMethodByCallBack, cacheTypes, postMethodByCallBack } from "../../../store/api/CommonFunctions";

export function addNewProductRequest(data, fn) {
  const _header = getheader();
  const api = data.ID > 0 ? "EditProductRequest" : "AddNewProductRequest";
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "ُSAVE_Product_Request",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductRequestAPI/" + api, {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت درخواست قطعه");
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت درخواست قطعه");
        dispatch({
          type: "FETCH_Product_Request",
          data: res
        });
        if (fn) {
          fn(res.SegmentList, res.ID);
        }
      }).catch((e) => console.log(e));
  }
}
export function getProductRequest(id, fn) {
  const _header = getheader();
  return dispatch => {
    dispatch({
      type: "FETCH_Product_Request",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductRequestAPI/GetProductRequest?id=" + id, {
      method: "GET",
      cache: "default",
      headers: _header
    })
      .then(res => res.json())
      .then(res => {
        if (res === "ERROR") {
          alert("اشکال در دریافت اطلاعات");
          return;
        }
        if (fn) {
          fn(res);
        }
        return dispatch({
          type: "FETCH_Product_Request",
          data: res
        })

      })
  }
}
export function setProductRequest(data) {
  return dispatch => {
    dispatch({
      type: "FETCH_Product_Request",
      data: data
    });
  }
}
export function deleteProductRequest(id, fn) {
  const _header = getheader();
  return dispatch => {
    fetch(serverUrl + "api/ProductRequestAPI/DeleteProductRequest?id=" + id, {
      method: "GET",
      cache: "default",
      headers: _header
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف درخواست");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف درخواست");
        if (fn) {
          fn(res);
        }

      }).catch(e => console.log("[DELETE_PRODUCT_REQUEST]", e))
  }
}
export function resetProductRequest() {
  let data = {};
  data.ID = -1;
  data.IsNew = true;
  return dispatch => {
    dispatch({
      type: "FETCH_Product_Request",
      data: data
    })
  }
}
export function searchProductRequest(model) {
  return dispatch => {
    dispatch({
      type: "SERCH_PRODUCT_REQUEST",
      data: "PENDING"
    });
    dispatch({
      type: "PRODUCT_REQUEST_FILTERS",
      data: model
    });
    fetch(serverUrl + "api/ProductRequestAPI/SearchProductRequest", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(model),
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی درخواستها");
          res = null;
        }
        dispatch({
          type: "SERCH_PRODUCT_REQUEST",
          data: res
        });
      }).catch(e => console.log("SERCH_PRODUCT_REQUEST:", e))
  }
}
export function addNewProductRequestKala(data, fn) {
  const _header = getheader();
  data = JSON.stringify(data)
  return dispatch => {
    dispatch({
      type: "ُSAVE_Product_RequestKala",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductRequestAPI/AddNewProductRequestKala", {
      body: data,
      headers: _header,
      method: "POST"
    })
      .then(res => res.json())
      .then(res => {
        if (res.Message || isNaN(res)) {
          let msg = res.Message ? res.Message : res;
          setErrorDialog(dispatch, res.Message, "ثبت درخواست قطعه");
          //res = null;
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت درخواست قطعه");
        dispatch({
          type: "ُSAVE_Product_RequestKala",
          data: res
        });
        if (fn) {
          fn(Number(res));
        }
      }).catch((e) => console.log(e));
  }
}
export function deleteProductRequestKala(id, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductRequestAPI/DeleteProductRequestKala?id=" + id, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف ردیف درخواست");
        }
        else {
          setErrorDialog(dispatch, "success", "حذف ردیف درخواست");
          if (fn) {
            fn();
          }
        }
      })
      .catch(e => console.log("DELETE_PRODUCT_REQUEST_KALA", e))
  }
}
export function getProductRequestComments(requestID) {
  return dispatch => {
    dispatch({
      type: "FETCH_PR_COMMENTS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductRequestAPI/GetProductRequestComments?requestID=" + requestID, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت ملاحظات درخواست");
          res = null;
        }
        dispatch({
          type: "FETCH_PR_COMMENTS",
          data: res
        })
      }).catch(e => {
        setErrorDialog(dispatch, "Error", "دریافت ملاحظات درخواست");
        dispatch({
          type: "FETCH_PR_COMMENTS",
          data: null
        });
        console.log("[FETCH_PR_COMMENTS]", e);
      });
  }
}
export function addNewProductRequestComment(requestID, comment, fn) {
  return dispatch => {
    fetch(serverUrl + `api/ProductRequestAPI/AddNewProductRequestComment?requestID=${requestID}&comment=${comment}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت نظر");
          res = null;
          return;
        }
        setErrorDialog(dispatch, "success", "ثبت نظر");
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[ADD_NEW_COMMENT]", e));
  }
}
export function setRequestCommentsPopup(data) {
  return dispatch => {
    dispatch({
      type: "PRODUCT_REQUEST_MESSAGE_POP",
      data: data
    });
  }
}
export function setPopChangeRequestStatus(data) {
  return dispatch => {
    dispatch({
      type: "POP_CHANGE_REQUEST_STATUS",
      data: data
    });
  }
}
export function changeStatusToInit(requestID, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductRequestAPI/ChangeStatusToInit?requestID=" + requestID, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ارسال درخواست");
          return;
        }
        setErrorDialog(dispatch, "success", "ارسال درخواست");
        if (fn) {
          fn();
        }
      }).catch(e => console.log("[ChangeStatusToSend]", e));
  }
}
export function getProductRequestStatusList() {
  return dispatch => {
    dispatch({
      type: "FETCH_REQUEST_STATUS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductRequestAPI/GetProductRequestStatusList", {
      headers: getheader(),
      method: "GET",
      cache: "default"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "FETCH_REQUEST_STATUS",
          data: res
        });
      }).catch(e => console.log("[FETCH_REQUEST_STATUS]", e))
  }
}
export function changeRequestStatus(requestID, statusID, desc, fn) {
  return dispatch => {
    fetch(serverUrl + `api/ProductRequestAPI/ChangeRequestStatus?requestID=${requestID}&statusID=${statusID}&desc=${desc}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "تغییر وضعیت درخواست");
          return;
        }
        setErrorDialog(dispatch, "success", "تغییر وضعیت درخواست");
        if (fn) {
          fn(res);
        }
      }).catch(e => {
        setErrorDialog(dispatch, "Error", "تغییر وضعیت درخواست");
        console.log("[ChangeRequestStatus]", e);
      });
  }
}
/**
 * 
 * @param {{InvoiceType: string, RequestID: Long, CustomerID: Long, StorageID: int}} data 
 * 
 * @param {function} fn 
 */
export function addNewInvoiceForRequest(data, fn) {
  postMethodByCallBack("api/InvoiceAPI/AddNewInvoiceForProductRequest", data, fn, "AddNewPurchaseForProductRequest");
}


